export function IconBook({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.583 1.667H16.833V18.333H5.583C5.031 18.333 4.501 18.113 4.11 17.723C3.719 17.332 3.5 16.802 3.5 16.25V3.75C3.5 3.197 3.719 2.667 4.11 2.276C4.501 1.886 5.031 1.667 5.583 1.667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 16.25C3.5 15.697 3.719 15.167 4.11 14.777C4.501 14.386 5.031 14.167 5.583 14.167H16.833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
